// Module
var code = "<div class=\"ToolBarPreview\"> <label> <i class=\"fa fa-object-group\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;